import { FC, useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { CommonPageLayout } from 'src/components/common/CommonPageLayout'
import EquipmentCategoryContainer from 'src/containers/Equipment/EquipmentCategoryContainer'
import { AppTextField } from 'src/components/AppTextField'
import { InputAdornment } from '@mui/material'
import { Search } from '@mui/icons-material'
import { MainComponentFilters } from 'src/generated-types/main-component'
import debounce from 'lodash/debounce'

const EquipmentPage: FC = () => {
  const { t: translate } = useTranslation(['main-component-type', 'common', 'main-component'])
  const [searchText, setSearchText] = useState('')
  const [inputValue, setInputValue] = useState('')
  const [headerFilters, setHeaderFilters] = useState<MainComponentFilters>({})

  const handleSearch = useCallback((text: string) => {
    setSearchText(text)
  }, [])

  const handleHeaderFiltersChange = useCallback((filters: MainComponentFilters) => {
    setHeaderFilters(filters)
  }, [])

  const debouncedSearch = useCallback(
    debounce(nextValue => handleSearch(nextValue), 400),
    [handleSearch],
  )

  const handleChange = useCallback(
    event => {
      const value = event.target.value
      setInputValue(value)
      debouncedSearch(value)
    },
    [debouncedSearch],
  )

  const searchField = (
    <AppTextField
      key="search"
      placeholder={translate('search', { ns: 'common' })}
      size="small"
      value={inputValue}
      onChange={evt => handleChange(evt)}
      autoComplete="off"
      sx={{
        py: 0,
        px: 0,
        minWidth: '220px',
        '& .MuiOutlinedInput-root': { height: '36px' },
      }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <Search fontSize="small" />
          </InputAdornment>
        ),
      }}
    />
  )

  return (
    <CommonPageLayout titleSection={{}} titleContainerProps={{ sx: { display: 'none' } }}>
      <EquipmentCategoryContainer
        searchText={searchText}
        onHeaderFiltersChange={handleHeaderFiltersChange}
        headerFilters={headerFilters}
        searchField={searchField}
      />
    </CommonPageLayout>
  )
}

export default EquipmentPage
